import React from 'react';

import { Field } from '@atlaskit/form';

import RecentAndMoreProjectSelect from '@qality/common-components/src/select/RecentAndMoreProjectSelect';

export const ProjectSelectView = ({
  input,
  meta,
  label,
  isRequired,
  useAllOption,
  isClearable,
  placeholder,
  isDisabled,
}: any) => {
  return (
    <Field label={label} isRequired={isRequired} name={input.name}>
      {() => (
        <RecentAndMoreProjectSelect
          onChange={input.onChange}
          onBlur={input.onBlur}
          useAllOption={useAllOption}
          value={input.value}
          isInvalid={meta.touched && !!meta.error}
          isClearable={isClearable}
          showLabel={false}
          addNameOfFilter={false}
          placeholder={placeholder}
          isDisabled={isDisabled}
        />
      )}
    </Field>
  );
};
